import Joi from "joi-browser";
import _ from "lodash";
import { createRef } from "react";
import { Dropdown, OverlayTrigger, Popover } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

//  Images
import arrowIcon1 from "include/images/arrow-down-icon-1.svg";
import arrowIcon2 from "include/images/arrow-down-icon-2.svg";
import arrowIcon from "include/images/arrow-down-icon.svg";
import carrentIcon from "include/images/carrent-icon.svg";
import filterIcon from "include/images/filter-icon.svg";
import emptyIcon from "include/images/nrf.svg";
import userIcon from "include/images/user.png";
import loadingIcon from "include/images/loader-grey.svg";

//  Components
import AlertError from "common/alert/alertError";
import AlertModal from "common/alert/alertModal";
import AlertSuccess from "common/alert/alertSuccess";
import Form from "common/form/form";
import SelectSearch from "common/form/selectSearch";
import NextButton from "common/form/submitButton";
import Header from "common/header";
import Loader from "common/loader";
import SideBar from "common/sidebar";
import closeIcon from "include/images/close-icon.svg";
import moment from "moment";
import { toast } from "react-toastify";
import {
  deleteUserBattleGame,
  getTelegram,
  loadRecentVerisoulAuthResultById,
  loadTelegramUsers,
  loadVerisoulMultipleTelegramAccountsById,
  recentVerisoulAuthResultByIdRequestCompleted,
  recentVerisoulAuthResultByIdRequested,
  resetUserData,
  resetUserSpin,
  updateTelegramUserStatus,
  updateTelegramUserStatusReceived,
} from "store/telegram";
import ListingActivitiesFlyer from "./listingActivitiesFlyer";
import SendNotificationFlyer from "./sendNotificationFlyer";
import SuspendUserFlyer from "./suspendUserFlyer";
import AuthResultsFlyer from "./authResultsFlyer";
import LinkedAccounts from "../verisoul/linkedAccounts";
import ListingTeammates from "./listingTeammates";
import { formatDate } from "utils/dateConversion";
import AddGearsFlyer from "./addGearsFlyer";
import AddCreditRewards from "./addCreditRewards";
import DeductCreditRewards from "./deductCreditRewards";

class UserListing extends Form {
  ref = createRef(null);

  state = {
    data: {
      userName: "",
      firstName: "",
      lastName: "",
      points: "",
      tickets: "",
      superVerseBalance: "",
      usdtBalance: "",
      country: "",
      referredBy: null,
      verisoulDecision: null,
      startDate: null,
      endDate: null,
    },
    showSuspendUser: false,
    showUnsuspendModal: false,
    showSendNotification: false,
    showTeammates: false,
    loadingResetSpin: false,
    sorting: { sort: "createdAt", order: "desc" },
    errors: {},
    loading: false,
    showFilters: false,
    showVerisoulStats: false,
    page: 1,
    appliedFilters: {},
    showAssignGears: false,
    showResetBattleGame: false,
    loadingDeleteUserBattle: false,
    loadingDeleteUserData: false,
    showAddCreditModal: false,
    showDeductCreditModal: false,
    showResetSpin: false,
    reward: 1,
  };
  componentDidUpdate = (prevProps, prevState) => {
    if (!this.props.getTelegram.loading && this.props.getTelegram.loading !== prevProps.getTelegram.loading)
      this.ref.current.complete();

    if (this.props.getTelegram.loading && this.props.getTelegram.loading !== prevProps.getTelegram.loading)
      this.ref.current.continuousStart();
  };

  componentDidMount = () => {
    this.setState({ loading: true });
    const params = { sort: "createdAt", order: "desc", page: 1 };
    this.props.loadTelegramUsers(params, (res) => {
      if (res?.status === 200) {
        this.setState({
          loading: false,
        });
      } else this.setState({ loading: false });
    });
  };

  //  Filters
  searchFilters = () => {
    const data = { ...this.state.data };
    const sorting = { ...this.state.sorting };

    const payLoad = {
      userName: data?.userName,
      firstName: data?.firstName,
      lastName: data?.lastName,
      country: data?.country,
      referredBy: data?.referredBy?.value,
      verisoulDecision: data?.verisoulDecision?.value,
      sort: sorting?.sort,
      order: sorting?.order,
    };
    if (data?.startDate) {
      payLoad.startDate = parseInt(formatDate(data?.startDate, "x"));
    }
    if (data?.endDate) {
      payLoad.endDate = parseInt(formatDate(data?.endDate, "x"));
    }
    if (data?.points) payLoad.points = parseInt(data?.points);
    if (data?.tickets) payLoad.tickets = parseInt(data?.tickets);
    if (data?.superVerseBalance) payLoad.superVerseBalance = parseInt(data?.superVerseBalance);
    if (data?.usdtBalance) {
      if (parseFloat(data?.usdtBalance) >= 0.1) payLoad.usdtBalance = parseFloat(data?.usdtBalance);
      else {
        return this.setState({ errors: { usdtBalance: "USDT must be greater than 0.1" } });
      }
    }

    if (!_.isEmpty(data.status)) {
      payLoad.status = data.status.value;
    }
    this.setState({ loadingFilters: true });
    var params = _.pickBy(payLoad, function (value, key) {
      return value !== "";
    });
    params.page = this.state.page;

    this.props.loadTelegramUsers(params, (userRes) => {
      if (userRes?.status === 200) {
        const data = { ...this.state.data };
        const appliedFilters = {};
        Object.keys(this.state.data).forEach((key) => {
          if (key === "startDate" || key === "endDate") {
            data[key] = parseInt(formatDate(data[key], "x"));
          }
          if (!_.isEmpty(data[key]) || ((key === "startDate" || key === "endDate") && data[key])) {
            appliedFilters[key] = data[key];
          }
        });
        this.setState({
          appliedFilters,
          loading: false,
          loadingMore: false,
          loadingFilters: false,
        });
      } else this.setState({ loading: false, loadingFilters: false });
    });
  };
  resetFilters = (e) => {
    e.preventDefault();
    this.setState(
      {
        data: {
          userName: "",
          points: "",
          tickets: "",
          superVerseBalance: "",
          usdtBalance: "",
          country: "",
          firstName: "",
          lastName: "",
          referredBy: null,
          verisoulDecision: null,
          startDate: null,
          endDate: null,
        },
        page: 1,
      },
      () => this.searchFilters(),
    );
  };

  onChange = (e) => {
    const data = this.state.data;
    const errors = this.state.errors;
    data[e.name] = e.currentTarget;
    delete errors[e.name];
    this.setState({ data, errors });
  };

  toggleActivitiesFlyer = (e) => {
    if (e) e.preventDefault();
    this.setState({ showActivitiesList: !this.state.showActivitiesList });
  };
  toggleTeammatesFlyer = (e) => {
    if (e) e.preventDefault();
    this.setState({ showTeammates: !this.state.showTeammates });
  };
  toggleSendNotificationFlyer = (e) => {
    if (e) e.preventDefault();
    this.setState({ showSendNotification: !this.state.showSendNotification });
  };
  toggleVerisoulStatsFlyer = (e) => {
    if (e) e.preventDefault();
    this.setState({ showVerisoulStats: !this.state.showVerisoulStats });
  };
  toggleLinkedAccountsFlyer = (e) => {
    if (e) e.preventDefault();
    this.setState({ showLinkedAccounts: !this.state.showLinkedAccounts });
  };
  loadLinkedAccounts = (e, user) => {
    this.setState({ user: user }, () => {
      this.toggleLinkedAccountsFlyer(e);
    });
    this.props.loadVerisoulMultipleTelegramAccountsById(user?._id);
  };
  toggleAssignGearsFlyer = (e) => {
    if (e) e.preventDefault();
    this.setState({ showAssignGears: !this.state.showAssignGears });
  };

  schema = {
    userName: Joi.string().allow(""),
    referredBy: Joi.object().allow(null),
    verisoulDecision: Joi.object().allow(null),
    points: Joi.number().allow(""),
    tickets: Joi.number().allow(""),
    superVerseBalance: Joi.number().allow(""),
    usdtBalance: Joi.number().allow(""),
    country: Joi.string().allow(""),
    firstName: Joi.string().allow(""),
    lastName: Joi.string().allow(""),
    startDate: Joi.date().allow("", null),
    endDate: Joi.date().allow("", null),
  };
  sort = (e, type) => {
    if (e) e.preventDefault();
    const sorting = { ...this.state.sorting };
    if (type === 1) {
      if (sorting?.sort === "points" && sorting?.order === "desc") {
        sorting.order = "asc";
      } else {
        sorting.order = "desc";
      }
      sorting.sort = "points";
    } else if (type === 2) {
      if (sorting?.sort === "usdtBalance" && sorting?.order === "desc") {
        sorting.order = "asc";
      } else {
        sorting.order = "desc";
      }
      sorting.sort = "usdtBalance";
    } else if (type === 3) {
      if (sorting?.sort === "gearBoxNft" && sorting?.order === "desc") {
        sorting.order = "asc";
      } else {
        sorting.order = "desc";
      }
      sorting.sort = "gearBoxNft";
    } else if (type === 4) {
      if (sorting?.sort === "createdAt" && sorting?.order === "desc") {
        sorting.order = "asc";
      } else {
        sorting.order = "desc";
      }
      sorting.sort = "createdAt";
    } else if (type === 5) {
      if (sorting?.sort === "firstName" && sorting?.order === "desc") {
        sorting.order = "asc";
      } else {
        sorting.order = "desc";
      }
      sorting.sort = "firstName";
    } else if (type === 6) {
      if (sorting?.sort === "verisoulDecision" && sorting?.order === "desc") {
        sorting.order = "asc";
      } else {
        sorting.order = "desc";
      }
      sorting.sort = "verisoulDecision";
    } else if (type === 7) {
      if (sorting?.sort === "country" && sorting?.order === "desc") {
        sorting.order = "asc";
      } else {
        sorting.order = "desc";
      }
      sorting.sort = "country";
    } else if (type === 8) {
      if (sorting?.sort === "tickets" && sorting?.order === "desc") {
        sorting.order = "asc";
      } else {
        sorting.order = "desc";
      }
      sorting.sort = "tickets";
    } else if (type === 9) {
      if (sorting?.sort === "superVerseBalance" && sorting?.order === "desc") {
        sorting.order = "asc";
      } else {
        sorting.order = "desc";
      }
      sorting.sort = "superVerseBalance";
    }
    this.setState({ sorting, page: 1 }, () => {
      this.searchFilters();
    });
  };
  suspendModalToggle = (e) => {
    if (e) e.preventDefault();
    this.setState({ showSuspendUser: !this.state.showSuspendUser });
  };
  alertModalToggle = (e) => {
    if (e) e.preventDefault();
    this.setState({ showUnsuspendModal: !this.state.showUnsuspendModal });
  };
  alertResetBattleModalToggle = (e) => {
    if (e) e.preventDefault();
    this.setState({ showResetBattleGame: !this.state.showResetBattleGame });
  };
  alertResetUserModalToggle = (e) => {
    if (e) e.preventDefault();
    this.setState({ showResetUserData: !this.state.showResetUserData });
  };
  alertResetSpinModalToggle = (e) => {
    if (e) e.preventDefault();
    this.setState({ showResetSpin: !this.state.showResetSpin });
  };
  handleSuspendUser = (e, status, reason, callback) => {
    if (e) e.preventDefault();
    this.props.updateTelegramUserStatus(
      {
        status,
        reason: reason,
      },
      this.state.user?._id,
      (userRes) => {
        if (userRes.status === 200) {
          toast(<AlertSuccess message="Information Saved!" />, {
            containerId: 1,
          });
          this.props.updateTelegramUserStatusReceived({
            _id: this.state.user._id,
            status,
            reason,
          });
          callback();
        } else {
          toast(<AlertError message={userRes.data && userRes.data.message} />, {
            containerId: 1,
          });
          callback();
        }
      },
    );
  };
  getEndDate = () => {
    if (this.state.data.startDate) {
      var startDate = new Date(this.state.data.startDate);
      var endDate = new Date(startDate.getTime());
      return endDate;
    } else {
      return null;
    }
  };
  handleLoadRecentVerisoulAuthResult = (show, id) => {
    const { recentVerisoulAuthResultById, recentVerisoulAuthResultByIdLoading } = this.props.getTelegram;
    if (show && !recentVerisoulAuthResultById[id] && !recentVerisoulAuthResultByIdLoading[id]) {
      this.props.recentVerisoulAuthResultByIdRequested(id);
      this.props.loadRecentVerisoulAuthResultById(id, (res) => {
        if (res?.status !== 200) {
          toast(<AlertError message={res.data && res.data.message} />, {
            containerId: 1,
          });
        }
        this.props.recentVerisoulAuthResultByIdRequestCompleted(id);
      });
    }
  };
  handleResetBattleGame = (e) => {
    if (e) e.preventDefault();
    this.setState({ loadingDeleteUserBattle: true });

    this.props.deleteUserBattleGame(this.state.user?._id, (userRes) => {
      if (userRes?.status === 200) {
        toast(<AlertSuccess message="Information Saved!" />, {
          containerId: 1,
        });
      } else {
        toast(<AlertError message={userRes.data && userRes.data.message} />, {
          containerId: 1,
        });
      }
      this.setState({ loadingDeleteUserBattle: false });
      this.alertResetBattleModalToggle();
    });
  };
  handleResetUserData = (e) => {
    if (e) e.preventDefault();
    this.setState({ loadingDeleteUserData: true });

    this.props.resetUserData(this.state.user?._id, (userRes) => {
      if (userRes?.status === 200) {
        toast(<AlertSuccess message="Information Saved!" />, {
          containerId: 1,
        });
      } else {
        toast(<AlertError message={userRes.data && userRes.data.message} />, {
          containerId: 1,
        });
      }
      this.setState({ loadingDeleteUserData: false });
      this.alertResetUserModalToggle();
    });
  };
  handleResetSpin = (e) => {
    if (e) e.preventDefault();
    this.setState({ loadingResetSpin: true });
    this.props.resetUserSpin(this.state.user?._id, (userRes) => {
      if (userRes?.status === 200) {
        toast(<AlertSuccess message="Information Saved!" />, {
          containerId: 1,
        });
      } else {
        toast(<AlertError message={userRes.data && userRes.data.message} />, {
          containerId: 1,
        });
      }
      this.setState({ loadingResetSpin: false });
      this.alertResetSpinModalToggle();
    });
  };
  toggleAddCreditRewardFlyer = (e) => {
    if (e) e.preventDefault();
    this.setState({ showAddCreditModal: !this.state.showAddCreditModal });
  };
  toggleDeductCreditRewardFlyer = (e) => {
    if (e) e.preventDefault();
    this.setState({ showDeductCreditModal: !this.state.showDeductCreditModal });
  };
  render() {
    const {
      telegramUsers,
      totalCount,
      verisoulMultipleTelegramAccountsById,
      verisoulMultipleTelegramAccountsByIdLoading,
      recentVerisoulAuthResultById,
      recentVerisoulAuthResultByIdLoading,
      filteredCount,
    } = this.props.getTelegram;
    return (
      <>
        <Header history={this.props.history} />
        <Loader loaderRef={this.ref} />
        <div className="page-wrapper add-dev-server-wrapper">
          <SideBar page="telegram-mini-app-users" />
          <div className="main-content-wrapper position-relative">
            <div className="mcw-header d-flex align-items-center">
              <h1>Telegram Users {totalCount > 0 && `(${totalCount})`}</h1>
              <div className="filter-menu-box d-flex align-items-center ms-auto">
                <div className="fmb-box">
                  <a
                    href="#!"
                    className="filter-link-box"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ showFilters: !this.state.showFilters });
                    }}
                  >
                    <img src={filterIcon} /> <span>Filters</span>
                  </a>
                </div>
                <div className="fmb-box">
                  <button
                    className="btn btn-default btn-sm"
                    onClick={(e) => {
                      this.setState({ user: "all" }, () => {
                        this.toggleSendNotificationFlyer(e);
                      });
                    }}
                  >
                    Broadcast Telegram Notification
                  </button>
                </div>
              </div>
            </div>
            <div className="fwc-wrapper">
              {this.state.showFilters && (
                <div className="fwc-head ">
                  <div className="fwc-inner">
                    <ul className="filter-mode-list question-filter-mode-list d-flex flex-wrap align-items-center">
                      <li className="flex-fill">
                        <div className="fml-box">{this.renderInput("userName", "Username")}</div>
                      </li>
                      <li className="flex-fill">
                        <div className="fml-box">{this.renderInput("firstName", "First Name")}</div>
                      </li>
                      <li className="flex-fill">
                        <div className="fml-box">{this.renderInput("lastName", "Last Name")}</div>
                      </li>
                      <li className="flex-fill">
                        <div className="fml-box">{this.renderInput("points", "Points Greater Than", "", "number")}</div>
                      </li>
                      <li className="flex-fill">
                        <div className="fml-box">
                          {this.renderInput("tickets", "Tickets Greater Than", "", "number")}
                        </div>
                      </li>
                      <li className="flex-fill">
                        <div className="fml-box">
                          {this.renderInput("superVerseBalance", "Superverse Token Greater Than", "", "number")}
                        </div>
                      </li>
                      <li className="flex-fill">
                        <div className="fml-box">{this.renderInput("usdtBalance", "USDT Greater Than")}</div>
                      </li>
                      <li className="flex-fill">
                        <div className="fml-box">{this.renderInput("country", "Country")}</div>
                      </li>
                      <li className="flex-fill">
                        <div className="fml-box">
                          <label className="form-label">Verisoul Decision</label>
                          <SelectSearch
                            name="verisoulDecision"
                            options={[
                              {
                                name: "Real",
                                value: "Real",
                              },
                              {
                                name: "Fake",
                                value: "fake",
                              },
                            ]}
                            label=""
                            value={this.state.data.verisoulDecision}
                            error={this.state.errors.verisoulDecision}
                            onChange={this.onChange}
                          />
                        </div>
                      </li>{" "}
                      <li className="flex-fill">
                        <div className="fml-box">
                          <div className="fml-input-group d-flex align-items-center">
                            <div className="fml-input-group-item flex-grow-1">
                              {" "}
                              {this.renderDateInput("startDate", "Start Date & Time ( In EST )", null)}
                            </div>
                          </div>
                        </div>
                      </li>
                      <li className="flex-fill">
                        <div className="fml-box">
                          <div className="fml-input-group d-flex align-items-center">
                            <div className="fml-input-group-item flex-grow-1">
                              {" "}
                              {this.renderDateInput("endDate", "End Date & Time ( In EST )", this.getEndDate())}
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <div className="fwc-btn d-flex align-items-center justify-content-end">
                      <NextButton
                        handleSubmit={this.resetFilters}
                        classData="btn-text pointer"
                        label="Reset"
                        loading={this.state.loadingReset}
                      />
                      <NextButton
                        handleSubmit={() => {
                          this.setState(
                            {
                              page: 1,
                            },
                            () => this.searchFilters(),
                          );
                        }}
                        classData="btn btn-primary btn-sm"
                        label="Search"
                        loading={this.state.loadingFilters}
                      />
                    </div>
                  </div>{" "}
                  {!_.isEmpty(this.state.appliedFilters) && (
                    <div className="filter-tag-container d-flex align-items-center ">
                      <div className="fwc-left">
                        <div className="filter-tag-list">
                          <p>Filter applied :</p>
                          {Object.keys(this.state.appliedFilters).map((key) => (
                            <div className="filter-tag-item">
                              <span className="camelCase">
                                {key === "userName"
                                  ? "Username"
                                  : key === "firstName"
                                  ? "First Name"
                                  : key === "lastName"
                                  ? "Last Name"
                                  : key === "points"
                                  ? "Points Greater Than"
                                  : key === "tickets"
                                  ? "Tickets Greater Than"
                                  : key === "superVerseBalance"
                                  ? "Superverse Token Greater Than"
                                  : key === "usdtBalance"
                                  ? "USDT Greater Than"
                                  : key === "referredBy"
                                  ? "Referred"
                                  : key === "verisoulDecision"
                                  ? "Verisoul Decision"
                                  : key === "country"
                                  ? "Country"
                                  : key === "startDate"
                                  ? "Start Date & Time ( In EST )"
                                  : key === "endDate"
                                  ? "End Date & Time ( In EST )"
                                  : key}
                              </span>{" "}
                              :{" "}
                              {key === "referredBy" || key === "verisoulDecision"
                                ? this.state.appliedFilters[key].name
                                : key === "startDate" || key === "endDate"
                                ? formatDate(this.state.appliedFilters[key], "MM/DD/YYYY hh:mm A")
                                : this.state.appliedFilters[key]}
                              {key !== "status" && (
                                <a
                                  href="#!"
                                  onClick={(e) => {
                                    e.preventDefault();

                                    this.setState(
                                      {
                                        data: {
                                          ...this.state.data,
                                          [key]: key === "startDate" || key === "endDate" ? null : "",
                                        },
                                        page: 1,
                                      },
                                      this.searchFilters,
                                    );
                                  }}
                                >
                                  <img src={closeIcon} alt="" />
                                </a>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
              <div className="">
                {" "}
                <div className="fwc-body">
                  {!this.state.loading && (
                    <div className="table-responsive">
                      {telegramUsers?.length === 0 ? (
                        <div className="fwc-body">
                          <div className="no-record-found-container">
                            <div className="nfr-box">
                              <img src={emptyIcon} alt="No Record Found" />
                              <div className="nrf-text">
                                <h5>No Records Found!</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <table className="table large-table">
                          <thead>
                            <tr>
                              <th style={{ textAlign: "center" }}>Actions</th>
                              <th>
                                Users
                                <a href="#!" onClick={(e) => this.sort(e, 5)}>
                                  <img
                                    src={
                                      this.state.sorting?.sort === "firstName"
                                        ? this.state.sorting?.order === "desc"
                                          ? arrowIcon1
                                          : arrowIcon2
                                        : arrowIcon
                                    }
                                    alt=""
                                  />
                                </a>
                              </th>
                              <th>
                                Decision
                                <a href="#!" onClick={(e) => this.sort(e, 6)}>
                                  <img
                                    src={
                                      this.state.sorting?.sort === "firstName"
                                        ? this.state.sorting?.order === "desc"
                                          ? arrowIcon1
                                          : arrowIcon2
                                        : arrowIcon
                                    }
                                    alt=""
                                  />
                                </a>
                              </th>
                              <th width={150}>
                                Points
                                <a href="#!" onClick={(e) => this.sort(e, 1)}>
                                  <img
                                    src={
                                      this.state.sorting?.sort === "points"
                                        ? this.state.sorting?.order === "desc"
                                          ? arrowIcon1
                                          : arrowIcon2
                                        : arrowIcon
                                    }
                                    alt=""
                                  />
                                </a>
                              </th>
                              <th width={150}>
                                Tickets
                                <a href="#!" onClick={(e) => this.sort(e, 8)}>
                                  <img
                                    src={
                                      this.state.sorting?.sort === "tickets"
                                        ? this.state.sorting?.order === "desc"
                                          ? arrowIcon1
                                          : arrowIcon2
                                        : arrowIcon
                                    }
                                    alt=""
                                  />
                                </a>
                              </th>
                              <th width={150}>
                                USDT
                                <a href="#!" onClick={(e) => this.sort(e, 2)}>
                                  <img
                                    src={
                                      this.state.sorting?.sort === "usdtBalance"
                                        ? this.state.sorting?.order === "desc"
                                          ? arrowIcon1
                                          : arrowIcon2
                                        : arrowIcon
                                    }
                                    alt=""
                                  />
                                </a>
                              </th>
                              <th width={150}>
                                Superverse Token
                                <a href="#!" onClick={(e) => this.sort(e, 9)}>
                                  <img
                                    src={
                                      this.state.sorting?.sort === "superVerseBalance"
                                        ? this.state.sorting?.order === "desc"
                                          ? arrowIcon1
                                          : arrowIcon2
                                        : arrowIcon
                                    }
                                    alt=""
                                  />
                                </a>
                              </th>
                              <th width={150}>Team Size</th>
                              <th width={150}>Status</th>
                              <th>
                                Country
                                <a href="#!" onClick={(e) => this.sort(e, 7)}>
                                  <img
                                    src={
                                      this.state.sorting?.sort === "country"
                                        ? this.state.sorting?.order === "desc"
                                          ? arrowIcon1
                                          : arrowIcon2
                                        : arrowIcon
                                    }
                                    alt=""
                                  />
                                </a>
                              </th>
                              <th width={150}>
                                Date
                                <a href="#!" onClick={(e) => this.sort(e, 4)}>
                                  <img
                                    src={
                                      this.state.sorting?.sort === "createdAt"
                                        ? this.state.sorting?.order === "desc"
                                          ? arrowIcon1
                                          : arrowIcon2
                                        : arrowIcon
                                    }
                                    alt=""
                                  />
                                </a>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {telegramUsers &&
                              telegramUsers?.length > 0 &&
                              telegramUsers?.map((user, i) => (
                                <tr>
                                  <td>
                                    <Dropdown className=" custom-dropdown">
                                      <Dropdown.Toggle
                                        id="tdDropdownOne"
                                        className="custom-dropdown-toggle"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <img src={carrentIcon} alt="" />
                                      </Dropdown.Toggle>
                                      <Dropdown.Menu className={`dropdown-menu-start `} aria-labelledby="tdDropdownOne">
                                        <Dropdown.Item
                                          className="dropdown-item"
                                          onClick={(e) => {
                                            this.setState({ user: user }, () => {
                                              this.toggleActivitiesFlyer(e);
                                            });
                                          }}
                                        >
                                          View Activities
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          className="dropdown-item"
                                          onClick={(e) => {
                                            this.setState({ user: user }, () => {
                                              this.toggleTeammatesFlyer(e);
                                            });
                                          }}
                                        >
                                          View Team
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          className="dropdown-item"
                                          onClick={(e) => {
                                            this.setState({ user: user }, () => {
                                              this.toggleSendNotificationFlyer(e);
                                            });
                                          }}
                                        >
                                          Send Telegram Notification
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          className="dropdown-item"
                                          onClick={(e) => {
                                            this.setState({ user: user }, () => {
                                              this.toggleVerisoulStatsFlyer(e);
                                            });
                                          }}
                                        >
                                          Verisoul Stats
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          className="dropdown-item"
                                          onClick={(e) => this.loadLinkedAccounts(e, user)}
                                        >
                                          Linked Accounts
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          className="dropdown-item"
                                          onClick={(e) => {
                                            this.setState({ user: user }, () => {
                                              this.toggleAssignGearsFlyer(e);
                                            });
                                          }}
                                        >
                                          Assign Gears
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          className="dropdown-item"
                                          onClick={(e) => {
                                            this.setState({ user: user }, () => this.alertResetUserModalToggle(e));
                                          }}
                                        >
                                          Reset User Data
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          className="dropdown-item"
                                          onClick={(e) => {
                                            this.setState({ user: user }, () => this.alertResetBattleModalToggle(e));
                                          }}
                                        >
                                          Reset Battle Game Data
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          className="dropdown-item"
                                          onClick={(e) => {
                                            this.setState({ user: user }, () => this.alertResetSpinModalToggle(e));
                                          }}
                                        >
                                          Reset Spin
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          className="dropdown-item"
                                          onClick={(e) => {
                                            this.setState({ user: user, rewardType: 1 }, () => {
                                              this.toggleAddCreditRewardFlyer(e);
                                            });
                                          }}
                                        >
                                          Free Points
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          className="dropdown-item"
                                          onClick={(e) => {
                                            this.setState({ user: user, rewardType: 2 }, () => {
                                              this.toggleAddCreditRewardFlyer(e);
                                            });
                                          }}
                                        >
                                          Free Spins
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          className="dropdown-item"
                                          onClick={(e) => {
                                            this.setState({ user: user, rewardType: 3 }, () => {
                                              this.toggleAddCreditRewardFlyer(e);
                                            });
                                          }}
                                        >
                                          Free Tickets
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          className="dropdown-item"
                                          onClick={(e) => {
                                            this.setState({ user: user, rewardType: 4 }, () => {
                                              this.toggleAddCreditRewardFlyer(e);
                                            });
                                          }}
                                        >
                                          Free Superverse Token
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          className="dropdown-item"
                                          onClick={(e) => {
                                            this.setState({ user: user, rewardType: 1 }, () => {
                                              this.toggleDeductCreditRewardFlyer(e);
                                            });
                                          }}
                                        >
                                          Deduct Points
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          className="dropdown-item"
                                          onClick={(e) => {
                                            this.setState({ user: user, rewardType: 2 }, () => {
                                              this.toggleDeductCreditRewardFlyer(e);
                                            });
                                          }}
                                        >
                                          Deduct Spins
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          className="dropdown-item"
                                          onClick={(e) => {
                                            this.setState({ user: user, rewardType: 3 }, () => {
                                              this.toggleDeductCreditRewardFlyer(e);
                                            });
                                          }}
                                        >
                                          Deduct Tickets
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          className="dropdown-item"
                                          onClick={(e) => {
                                            this.setState({ user: user, rewardType: 4 }, () => {
                                              this.toggleDeductCreditRewardFlyer(e);
                                            });
                                          }}
                                        >
                                          Deduct Superverse Token
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </td>
                                  <td>
                                    <span>
                                      <div className="td-img-group d-flex align-items-start ">
                                        <div
                                          className="td-img round-img m-right-2 pointer"
                                          onClick={(e) => {
                                            this.setState({ user: user }, () => {
                                              this.toggleActivitiesFlyer(e);
                                            });
                                          }}
                                        >
                                          {user.image ? (
                                            <img src={process.env.REACT_APP_CDN + user.image.small} alt="" />
                                          ) : (
                                            <img src={userIcon} alt="" />
                                          )}
                                        </div>

                                        <div>
                                          <a
                                            href="#!"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              this.setState({ user: user }, () => {
                                                this.toggleActivitiesFlyer(e);
                                              });
                                            }}
                                          >
                                            {user?.firstName} {user?.lastName}
                                          </a>
                                          <br />
                                          {user?.userName} <br />
                                          {user?.telegramId}
                                        </div>
                                      </div>
                                    </span>
                                  </td>
                                  <td className="ust-tag">
                                    {user?.verisoulDecision && (
                                      <OverlayTrigger
                                        placement="top"
                                        onToggle={(show) => this.handleLoadRecentVerisoulAuthResult(show, user?._id)}
                                        overlay={
                                          <Popover
                                            id="popoverPannel"
                                            className="custom-tooltip "
                                            data-bs-title="verisoulDecision"
                                          >
                                            <Popover.Body className="tooltip-inner tooltip-inner-reason">
                                              {recentVerisoulAuthResultByIdLoading[user?._id] ? (
                                                <div className="w-100 d-flex justify-content-center load-more">
                                                  <img src={loadingIcon} className="fa-spin" alt="" />
                                                </div>
                                              ) : (
                                                <>
                                                  <h4>
                                                    Account Score:{" "}
                                                    {recentVerisoulAuthResultById[user?._id]?.accountScore}
                                                  </h4>
                                                  <h4>Bot: {recentVerisoulAuthResultById[user?._id]?.bot}</h4>
                                                  <h4>
                                                    Multiple Accounts:{" "}
                                                    {recentVerisoulAuthResultById[user?._id]?.multipleAccounts}
                                                  </h4>
                                                  <h4>
                                                    Risk Signals: {recentVerisoulAuthResultById[user?._id]?.riskSignals}
                                                  </h4>
                                                </>
                                              )}
                                            </Popover.Body>
                                          </Popover>
                                        }
                                      >
                                        <span
                                          className={`text-center d-block tickets pointer ${
                                            user?.verisoulDecision === "Fake" && "suspended"
                                          } `}
                                          data-bs-toggle="tooltip"
                                          data-bs-placement="top"
                                          data-bs-custom-class="custom-tooltip"
                                          data-bs-title="verisoulDecision"
                                        >
                                          {user?.verisoulDecision}
                                        </span>
                                      </OverlayTrigger>
                                    )}
                                  </td>
                                  <td>{user?.points?.toLocaleString() ?? 0}</td>
                                  <td>{user?.tickets?.toLocaleString() ?? 0}</td>
                                  <td>{user?.usdtBalance?.toLocaleString("en-us") ?? 0}</td>
                                  <td>{user?.superVerseBalance?.toLocaleString("en-us") ?? 0}</td>
                                  <td>{user?.teamMates?.length ?? 0}</td>
                                  <td className="ust-tag">
                                    <Dropdown className="custom-dropdown">
                                      <Dropdown.Toggle
                                        id="tdDropdownOne"
                                        className="custom-dropdown-toggle"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <span
                                          className={`w-100 text-center d-block ${
                                            user.status === -1 ? "suspended" : user.status === 0 ? "inactive" : "active"
                                          }`}
                                        >
                                          {user.status === -1 ? "Suspended" : user.status === 0 ? "Inactive" : "Active"}
                                        </span>
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu className={`dropdown-menu-start `} aria-labelledby="tdDropdownOne">
                                        <Dropdown.Item
                                          className="dropdown-item "
                                          onClick={(e) => {
                                            this.setState({ user: user }, () =>
                                              user.status === -1
                                                ? this.alertModalToggle(e)
                                                : this.suspendModalToggle(e),
                                            );
                                          }}
                                        >
                                          {user.status === -1 ? "Activate" : "Suspend"} User
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </td>
                                  <td>{user?.location?.country}</td>
                                  <td>
                                    {moment(user.createdAt).format("MM/DD/YYYY")}
                                    <br />
                                    {moment(user.createdAt).format("hh:mm a")}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                  )}
                  {!this.state.loading && !(this.state.page === 1 && telegramUsers?.length === 0) && (
                    <div className="page-pagination">
                      <ul className="pagination  justify-content-end">
                        <li className="page-item">
                          <a
                            class={`page-link ${this.state.page === 1 && "disabled"}`}
                            href="#!"
                            aria-label="Previous"
                            onClick={(e) => {
                              e.preventDefault();
                              if (this.state.page > 1) {
                                this.setState({ page: this.state.page - 1 }, () => this.searchFilters());
                              }
                            }}
                          >
                            <svg
                              width="8"
                              height="14"
                              viewBox="0 0 8 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M7 13L1 7L7 1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </a>
                        </li>
                        <li className="page-item active">
                          <a
                            className="page-link"
                            href="#!"
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            {this.state.page}
                          </a>
                        </li>
                        {telegramUsers?.length >= 20 && (
                          <li className="page-item">
                            <a
                              className="page-link"
                              href="#!"
                              onClick={(e) => {
                                e.preventDefault();
                                this.setState({ page: this.state.page + 1 }, () => this.searchFilters());
                              }}
                            >
                              {this.state.page + 1}
                            </a>
                          </li>
                        )}
                        <li className="page-item">
                          <a
                            class={`page-link ${telegramUsers?.length < 20 && "disabled"}`}
                            href="#!"
                            aria-label="Next"
                            onClick={(e) => {
                              e.preventDefault();
                              this.setState({ page: this.state.page + 1 }, () => this.searchFilters());
                            }}
                          >
                            <svg
                              width="8"
                              height="14"
                              viewBox="0 0 8 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M1 13L7 7L1 1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </a>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>{" "}
        <ListingActivitiesFlyer
          showModal={this.state.showActivitiesList}
          toggleModal={this.toggleActivitiesFlyer}
          user={this.state.user}
        />{" "}
        <ListingTeammates
          showModal={this.state.showTeammates}
          toggleModal={this.toggleTeammatesFlyer}
          user={this.state.user}
        />
        <SendNotificationFlyer
          showModal={this.state.showSendNotification}
          toggleModal={this.toggleSendNotificationFlyer}
          user={this.state.user}
        />
        <SuspendUserFlyer
          showModal={this.state.showSuspendUser}
          toggleModal={this.suspendModalToggle}
          handleSuspendUser={this.handleSuspendUser}
        />
        <AuthResultsFlyer
          showModal={this.state.showVerisoulStats}
          toggleModal={this.toggleVerisoulStatsFlyer}
          user={this.state.user}
        />
        <LinkedAccounts
          showModal={this.state.showLinkedAccounts}
          toggleModal={this.toggleLinkedAccountsFlyer}
          user={{ ...this.state.user, linkedAccounts: verisoulMultipleTelegramAccountsById?.linkedAccounts || [] }}
          loading={verisoulMultipleTelegramAccountsByIdLoading}
          showUserImg={true}
        />
        <AlertModal
          alertModalToggle={this.alertModalToggle}
          alertModalShow={this.state.showUnsuspendModal}
          title="Alert"
          description="Are you sure you want to activate the user?"
          alertType="Yes"
          onPress={(e) => {
            this.setState({ loadingUnsuspend: true });
            this.handleSuspendUser(e, 1, "", () => {
              this.alertModalToggle();
              this.setState({ loadingUnsuspend: false });
            });
          }}
          loading={this.state.loadingUnsuspend}
        />
        <AlertModal
          alertModalToggle={this.alertResetBattleModalToggle}
          alertModalShow={this.state.showResetBattleGame}
          title="Alert"
          description="Are you sure you want to reset the user's battle game progress?"
          alertType="Yes"
          onPress={this.handleResetBattleGame}
          loading={this.state.loadingDeleteUserBattle}
        />
        <AlertModal
          alertModalToggle={this.alertResetUserModalToggle}
          alertModalShow={this.state.showResetUserData}
          title="Alert"
          description="Are you sure you want to reset the user's data?"
          alertType="Yes"
          onPress={this.handleResetUserData}
          loading={this.state.loadingDeleteUserData}
        />
        <AlertModal
          alertModalToggle={this.alertResetSpinModalToggle}
          alertModalShow={this.state.showResetSpin}
          title="Alert"
          description="Are you sure you want to reset the user's spin progress?"
          alertType="Yes"
          onPress={this.handleResetSpin}
          loading={this.state.loadingResetSpin}
        />
        <AddGearsFlyer
          showModal={this.state.showAssignGears}
          toggleModal={this.toggleAssignGearsFlyer}
          user={{ ...this.state.user }}
          reload={() => {
            this.setState({ page: 1 }, this.searchFilters);
          }}
        />
        <AddCreditRewards
          showModal={this.state.showAddCreditModal}
          toggleModal={this.toggleAddCreditRewardFlyer}
          rewardType={this.state.rewardType}
          user={this.state.user}
        />
        <DeductCreditRewards
          showModal={this.state.showDeductCreditModal}
          toggleModal={this.toggleDeductCreditRewardFlyer}
          rewardType={this.state.rewardType}
          user={this.state.user}
        />
        {(this.state.showActivitiesList ||
          this.state.showSuspendUser ||
          this.state.showSendNotification ||
          this.state.showVerisoulStats ||
          this.state.showTeammates ||
          this.state.showLinkedAccounts ||
          this.state.showAssignGears) && (
          <div
            className="modal-backdrop z-index-1000 show fade"
            onClick={
              this.state.showAssignGears
                ? this.toggleAssignGearsFlyer
                : this.state.showLinkedAccounts
                ? this.toggleLinkedAccountsFlyer
                : this.state.showTeammates
                ? this.toggleTeammatesFlyer
                : this.state.showVerisoulStats
                ? this.toggleVerisoulStatsFlyer
                : this.state.showSendNotification
                ? this.toggleSendNotificationFlyer
                : this.state.showSuspendUser
                ? this.suspendModalToggle
                : this.toggleActivitiesFlyer
            }
          ></div>
        )}
      </>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  loadTelegramUsers: (pramas, callback) => dispatch(loadTelegramUsers(pramas, callback)),
  updateTelegramUserStatus: (data, id, callback) => dispatch(updateTelegramUserStatus(data, id, callback)),
  loadVerisoulMultipleTelegramAccountsById: (id, callback) =>
    dispatch(loadVerisoulMultipleTelegramAccountsById(id, callback)),
  updateTelegramUserStatusReceived: (payLoad) => dispatch(updateTelegramUserStatusReceived(payLoad)),
  loadRecentVerisoulAuthResultById: (id, callback) => dispatch(loadRecentVerisoulAuthResultById(id, callback)),
  recentVerisoulAuthResultByIdRequested: (id) => dispatch(recentVerisoulAuthResultByIdRequested(id)),
  recentVerisoulAuthResultByIdRequestCompleted: (id) => dispatch(recentVerisoulAuthResultByIdRequestCompleted(id)),
  deleteUserBattleGame: (id, callback) => dispatch(deleteUserBattleGame(id, callback)),
  resetUserSpin: (id, callback) => dispatch(resetUserSpin(id, callback)),
  resetUserData: (id, callback) => dispatch(resetUserData(id, callback)),
});
const mapStateToProps = (state) => ({
  getTelegram: getTelegram(state),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserListing));
